// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"926":"c22e746e","957":"c22e746e","1912":"c22e746e","2480":"c22e746e","4048":"c22e746e","5845":"96e99df1","6217":"24dd3224"}[chunkId] + ".chunk.css";
};